import { render, staticRenderFns } from "./TherapistPortalV2.vue?vue&type=template&id=68daf76f"
import script from "./TherapistPortalV2.vue?vue&type=script&lang=js"
export * from "./TherapistPortalV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports